import React from 'react';
import { observer } from '../../shared/observer';

class HeaderCartView extends React.Component {
  render() {
    const c = this.props.cart.cart || {};
    // total_quantity — сумма штук, count — число позиций. Юзеру понятнее штуки.
    const qty = c.total_quantity || 0;
    // Всегда ссылка — даже пустая корзина ведёт на /cart (EmptyCart экран).
    return (
      <a className="ng-header__cart" href="/cart">
        <CartSvg />
        {qty > 0 && <span>{qty}</span>}
      </a>
    );
  }
}

function CartSvg() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  );
}

export const HeaderCart = observer(HeaderCartView, ['cartStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/HeaderCart.jsx